"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var SectionComponent_1 = require("../../SectionComponent");

var util_1 = require("../../SectionComponent/util");

var DefaultPageElementRenderer_1 = require("./DefaultPageElementRenderer");

function assembleRenderersFrom(contentElements) {
  return contentElements.map(function (section, index, arr) {
    var rendererProps = {};
    var sectionType = util_1.inferSectionType(section);
    var nextSectionType = index + 1 < arr.length && util_1.inferSectionType(arr[index + 1]);

    if (nextSectionType && nextSectionType !== sectionType) {
      rendererProps.separatorBottom = true;
    }

    if (sectionType === util_1.SectionType.Text) {
      rendererProps.centeredHeading = true;
    }

    return {
      rendererProps: rendererProps,
      component: SectionComponent_1.SectionComponent,
      data: [section],
      renderer: DefaultPageElementRenderer_1.DefaultPageElementRenderer
    };
  });
}

exports.assembleRenderersFrom = assembleRenderersFrom;
/**
 * Renders a list of Section elements.
 * Adjacent Sections with a different visual type (text only, text/media only,
 * text+text/media) will be separated visually.
 */

exports.AdjacentSectionsRenderer = function (_a) {
  // console.log('AdjacentSectionsRenderer');
  var data = _a.data;
  var renderers = assembleRenderersFrom(data);
  var children = renderers.map(function (renderer, index) {
    var Renderer = renderer.renderer;
    return react_1["default"].createElement(Renderer, {
      key: "AdjacentSectionsRenderer-" + index,
      data: renderer.data,
      component: renderer.component,
      props: renderer.rendererProps
    });
  });
  return react_1["default"].createElement(react_1["default"].Fragment, null, children);
};